import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  FetchGoCertificatePayload,
  FetchGoCertificatesShortenPayload,
  IGoCertificate,
  IGoCertificateShorten,
  UpdateGoCertificatePayload,
} from '../types/eecs-certificates.type';

export const eecsGoCertificateApi = createApi({
  reducerPath: 'eecsGoCertificateApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/necs/go-certificates`),
  endpoints: (builder) => ({
    fetchGoCertificates: builder.query<ApiPaginationResponse<IGoCertificate[]>, FetchGoCertificatePayload>({
      query: (params) => ({
        url: '/grouped',
        method: 'GET',
        params,
      }),
    }),

    fetchShortenGoCertificates: builder.query<
      ApiPaginationResponse<IGoCertificateShorten[]>,
      FetchGoCertificatesShortenPayload
    >({
      query: (params) => ({
        url: '/grouped/select',
        method: 'GET',
        params,
      }),
    }),

    updateGoCertificate: builder.mutation<ApiResponse<IGoCertificate>, UpdateGoCertificatePayload>({
      query: (payload) => ({
        url: `/update`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyFetchGoCertificatesQuery,
  useLazyFetchShortenGoCertificatesQuery,
  useUpdateGoCertificateMutation,
} = eecsGoCertificateApi;
